// extracted by mini-css-extract-plugin
module.exports = {"button":"button_2kPx1","dropzone":"dropzone_1B7AL","actions":"actions_cW2pe"};